var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo, useState, useCallback, forwardRef, useImperativeHandle, useEffect, useRef, } from "react";
import { Space, Typography, Divider, Tree, Button, List, Input, Modal, Select, message, } from "antd";
import { ClearOutlined, DatabaseOutlined, ThunderboltOutlined, SettingOutlined, LoadingOutlined, ReloadOutlined, } from "@ant-design/icons";
import ContainerPanel from "../containers/ContainerPanel";
import ContainerModal from "../containers/ContainerModal";
import CompsForm from "./CompsForm";
import { useAiComponentHook } from "../hooks/useAiComponentHook";
import axios from "axios";
import "./CompsAi.css";
var Title = Typography.Title, Paragraph = Typography.Paragraph, Text = Typography.Text;
/** 从 AI 返回的 results（按 methodId 聚合）中提取用于展示的纯文本，只取 data.content */
function getDisplayContentFromResults(results) {
    if (!results || typeof results !== "object")
        return "";
    var texts = [];
    Object.values(results).forEach(function (r) {
        var data = r === null || r === void 0 ? void 0 : r.data;
        if ((data === null || data === void 0 ? void 0 : data.content) != null && typeof data.content === "string") {
            texts.push(data.content.trim());
        }
    });
    return texts.join("\n\n");
}
/** 若 content 是之前存的完整 JSON，解析并只返回 data.content 的拼接；否则返回原字符串 */
function getDisplayContent(messageContent) {
    var s = (messageContent === null || messageContent === void 0 ? void 0 : messageContent.trim()) || "";
    if (!s)
        return "";
    if (s.startsWith("{") && s.includes('"data"')) {
        try {
            var parsed = JSON.parse(s);
            return getDisplayContentFromResults(parsed) || s;
        }
        catch (_a) {
            return s;
        }
    }
    return s;
}
/** 将内容中的 **...** 渲染为加粗，保留换行；不引入 HTML，安全 */
function renderContentWithFormatting(text) {
    var s = (text === null || text === void 0 ? void 0 : text.trim()) || "";
    if (!s)
        return null;
    var parts = s.split("**");
    if (parts.length <= 1)
        return s;
    return parts.map(function (part, i) {
        return i % 2 === 1 ? (_jsx(Text, __assign({ strong: true }, { children: part }), i)) : (_jsx(React.Fragment, { children: part }, i));
    });
}
/**
 * 从 payload 中抽取「结构」：保留字段名与层级，将具体值替换为类型占位（null/[]/""），
 * 用于编辑传入数据弹窗中仅展示结构、不展示数据，便于用户根据结构决定是否保存为待响应事件。
 */
function getPayloadStructure(val) {
    if (val === null || val === undefined)
        return null;
    if (Array.isArray(val)) {
        if (val.length === 0)
            return [];
        return [getPayloadStructure(val[0])];
    }
    if (typeof val === "object") {
        var obj = val;
        var out = {};
        for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
            var k = _a[_i];
            out[k] = getPayloadStructure(obj[k]);
        }
        return out;
    }
    if (typeof val === "string")
        return "";
    if (typeof val === "number")
        return null;
    if (typeof val === "boolean")
        return null;
    return null;
}
/**
 * 价格建议（房态动态定价）完整传入数据结构默认值
 * 当无样本或样本结构不完整时展示，避免「传入的数据结构」出现 dataSource[0] 为空对象等不全情况
 */
var DEFAULT_PRICE_SUGGESTION_INPUT_STRUCTURE = {
    storeId: "",
    componentType: "room-status",
    data: {
        timeDirection: "past",
        current: [
            {
                id: "",
                label: "",
                progress: null,
                quantity: null,
                quantityOpen: null,
                priceData: [],
                normalizedReferenceLines: [],
                isStoreTotal: null,
                progressColor: "",
                chartColor: "",
            },
        ],
        last7Days: null,
        last30Days: null,
        last12Months: null,
        priceSuggestionContext: {
            currentTime: "",
            overallOccupancy: null,
            remainingTotalRooms: null,
            orderFlowSpeed: "",
            externalFactors: "",
            roomStrategies: {},
            hasFollower: null,
            hasFollowed: null,
        },
    },
};
/** 判断数组首元素是否为空对象（无键或键为空） */
function isEmptyObject(v) {
    if (v == null || typeof v !== "object")
        return true;
    return Object.keys(v).length === 0;
}
/**
 * 当传入结构不完整时（如 current 或 current.dataSource 首项为空对象），用默认结构补全
 */
function ensureCompletePayloadStructure(raw, defaultStructure) {
    if (raw == null || typeof raw !== "object")
        return raw;
    var o = raw;
    var data = o.data;
    if (!data || typeof data !== "object")
        return raw;
    var defaultData = defaultStructure === null || defaultStructure === void 0 ? void 0 : defaultStructure.data;
    var defaultCurrent = defaultData === null || defaultData === void 0 ? void 0 : defaultData.current;
    var defaultItem = Array.isArray(defaultCurrent)
        ? defaultCurrent[0]
        : undefined;
    var current = data.current;
    // current 为数组且首项为空 → 用默认 current 替换
    if (Array.isArray(current) && defaultItem != null) {
        if (current.length === 0 || isEmptyObject(current[0])) {
            return __assign(__assign({}, o), { data: __assign(__assign({}, data), { current: defaultCurrent }) });
        }
    }
    // current 为 { dataSource: [...] } 且 dataSource 首项为空 → 用默认项补全 dataSource
    if (current && typeof current === "object") {
        var cur = current;
        var dataSource = cur.dataSource;
        if (Array.isArray(dataSource) && defaultItem != null) {
            if (dataSource.length === 0 || isEmptyObject(dataSource[0])) {
                return __assign(__assign({}, o), { data: __assign(__assign({}, data), { current: __assign(__assign({}, cur), { dataSource: defaultCurrent }) }) });
            }
        }
    }
    return raw;
}
/**
 * 从结构对象中收集所有字段路径（用于「选择数据」「脱敏字段」等，与具体数据无关）
 * 例如 { a: "", b: { c: "" } } => ["a", "b", "b.c"]
 */
function getFieldsFromStructure(structure, prefix) {
    if (prefix === void 0) { prefix = ""; }
    if (structure === null || structure === undefined)
        return [];
    if (Array.isArray(structure)) {
        return getFieldsFromStructure(structure[0], prefix);
    }
    if (typeof structure === "object") {
        var obj_1 = structure;
        return Object.keys(obj_1).flatMap(function (k) {
            var key = prefix ? "".concat(prefix, ".").concat(k) : k;
            var v = obj_1[k];
            if (v !== null && typeof v === "object") {
                var nested = getFieldsFromStructure(v, key);
                return nested.length > 0 ? __spreadArray([key], nested, true) : [key];
            }
            return [key];
        });
    }
    return [];
}
/** 添加/编辑思考方式对话框：核心问题、思维要求与禁止、必做操作、返回格式结构、返回格式要求与禁止，保存到数据库 */
function AddThinkingMethodDialog(_a) {
    var _this = this;
    var _b;
    var visible = _a.visible, onClose = _a.onClose, onSaved = _a.onSaved, pageId = _a.pageId, eventHash = _a.eventHash, token = _a.token, apiBaseUrl = _a.apiBaseUrl, existingMethods = _a.existingMethods, samplePayload = _a.samplePayload, initialMethod = _a.initialMethod;
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useState([]), datasets = _d[0], setDatasets = _d[1];
    var _e = useState(""), selectedDataset = _e[0], setSelectedDataset = _e[1];
    var _f = useState([]), selectedDataFields = _f[0], setSelectedDataFields = _f[1];
    var _g = useState(""), displayName = _g[0], setDisplayName = _g[1];
    var _h = useState(""), briefDesc = _h[0], setBriefDesc = _h[1];
    var _j = useState(""), question = _j[0], setQuestion = _j[1];
    /** 思维要求与禁止（合并原「思考方式需求」+「思考方式避免」） */
    var _k = useState(""), thinkingConstraints = _k[0], setThinkingConstraints = _k[1];
    var _l = useState(""), requiredActions = _l[0], setRequiredActions = _l[1];
    var _m = useState(""), returnStructure = _m[0], setReturnStructure = _m[1];
    /** 返回格式要求与禁止（合并原「返回格式需求」+「返回格式避免」） */
    var _o = useState(""), returnConstraints = _o[0], setReturnConstraints = _o[1];
    // 脱敏字段（多选）
    var _p = useState([]), sensitiveFields = _p[0], setSensitiveFields = _p[1];
    // 打开时：有 initialMethod 则回填表单，否则清空表单
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        if (!visible)
            return;
        if (initialMethod) {
            setDisplayName((_a = initialMethod.display_name) !== null && _a !== void 0 ? _a : "");
            setBriefDesc((_b = initialMethod.brief_desc) !== null && _b !== void 0 ? _b : "");
            setQuestion((_d = (_c = initialMethod.detail) === null || _c === void 0 ? void 0 : _c.question) !== null && _d !== void 0 ? _d : "");
            var aff = Array.isArray((_e = initialMethod.detail) === null || _e === void 0 ? void 0 : _e.affirmative_words)
                ? initialMethod.detail.affirmative_words.join("，")
                : "";
            var neg = Array.isArray((_f = initialMethod.detail) === null || _f === void 0 ? void 0 : _f.negative_words)
                ? initialMethod.detail.negative_words.join("，")
                : "";
            setThinkingConstraints(aff || neg ? "\u8981\u6C42\uFF1A".concat(aff, "\n\u7981\u6B62\uFF1A").concat(neg) : "");
            setRequiredActions(Array.isArray((_g = initialMethod.detail) === null || _g === void 0 ? void 0 : _g.required_actions)
                ? initialMethod.detail.required_actions.join("\n")
                : "");
            setReturnStructure((_k = (_j = (_h = initialMethod.return_format) === null || _h === void 0 ? void 0 : _h.format_detail) === null || _j === void 0 ? void 0 : _j.structure) !== null && _k !== void 0 ? _k : (initialMethod.display_name === "价格建议"
                ? "房型:当前价,建议价,理由"
                : ""));
            var retAff = Array.isArray((_m = (_l = initialMethod.return_format) === null || _l === void 0 ? void 0 : _l.format_detail) === null || _m === void 0 ? void 0 : _m.affirmative_words)
                ? initialMethod.return_format.format_detail.affirmative_words.join("，")
                : "";
            var retNeg = Array.isArray((_p = (_o = initialMethod.return_format) === null || _o === void 0 ? void 0 : _o.format_detail) === null || _p === void 0 ? void 0 : _p.negative_words)
                ? initialMethod.return_format.format_detail.negative_words.join("，")
                : "";
            setReturnConstraints(retAff || retNeg ? "\u8981\u6C42\uFF1A".concat(retAff, "\n\u7981\u6B62\uFF1A").concat(retNeg) : "");
            setSensitiveFields(Array.isArray(initialMethod.sensitive_fields)
                ? initialMethod.sensitive_fields
                : []);
            setSelectedDataFields(Array.isArray(initialMethod.selected_data_fields)
                ? initialMethod.selected_data_fields
                : []);
        }
        else {
            setDisplayName("");
            setBriefDesc("");
            setQuestion("");
            setThinkingConstraints("");
            setRequiredActions("");
            setReturnStructure("");
            setReturnConstraints("");
            setSensitiveFields([]);
            setSelectedDataFields([]);
        }
    }, [visible, initialMethod]);
    useEffect(function () {
        if (visible) {
            setLoading(true);
            var url = apiBaseUrl
                ? "".concat(apiBaseUrl.replace(/\/$/, ""), "/api/ai/get-datasets")
                : "/api/ai/get-datasets";
            (typeof fetch !== "undefined" ? fetch : globalThis.fetch)(url)
                .then(function (r) { return r.json(); })
                .then(function (res) {
                setDatasets(Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? res.data : []);
            })
                .catch(function () { return setDatasets([]); })
                .finally(function () { return setLoading(false); });
        }
    }, [visible, apiBaseUrl]);
    var currentDataset = datasets.find(function (d) { return d.dataset_id === selectedDataset; });
    var dataFields = (_b = currentDataset === null || currentDataset === void 0 ? void 0 : currentDataset.data_fields) !== null && _b !== void 0 ? _b : [];
    // 左侧：只展示数据结构（与具体数据无关）；无样本或结构不完整时用默认完整结构，避免 dataSource[0] 为空
    var payloadStructure = useMemo(function () {
        var raw = getPayloadStructure(samplePayload !== null && samplePayload !== void 0 ? samplePayload : {});
        var ensured = ensureCompletePayloadStructure(raw, DEFAULT_PRICE_SUGGESTION_INPUT_STRUCTURE);
        var isEmpty = !samplePayload ||
            (typeof raw === "object" &&
                raw !== null &&
                Object.keys(raw).length === 0);
        return isEmpty ? DEFAULT_PRICE_SUGGESTION_INPUT_STRUCTURE : ensured;
    }, [samplePayload]);
    var structureFields = useMemo(function () { return getFieldsFromStructure(payloadStructure); }, [payloadStructure]);
    var effectiveDataFields = samplePayload && structureFields.length > 0 ? structureFields : dataFields;
    var handleSave = useCallback(function () {
        var _a;
        if (!eventHash || !pageId) {
            message.error("缺少 eventHash 或 pageId，无法保存思考方式，请先保存传送信息。");
            return;
        }
        if (!(displayName === null || displayName === void 0 ? void 0 : displayName.trim())) {
            message.error("请填写方法名称");
            return;
        }
        if (!(question === null || question === void 0 ? void 0 : question.trim())) {
            message.error("请填写核心问题");
            return;
        }
        var methodId = (_a = initialMethod === null || initialMethod === void 0 ? void 0 : initialMethod.method_id) !== null && _a !== void 0 ? _a : "method-".concat(Date.now());
        var parseConstraints = function (text) {
            var req = [];
            var neg = [];
            if (!(text === null || text === void 0 ? void 0 : text.trim()))
                return { req: req, neg: neg };
            var banIdx = text.indexOf("禁止：");
            var reqPart = banIdx >= 0 ? text.slice(0, banIdx) : text;
            var negPart = banIdx >= 0 ? text.slice(banIdx + 3) : "";
            var reqStr = reqPart.replace(/^要求：?/, "").trim();
            req.push.apply(req, reqStr
                .split(/[,，\n]/)
                .map(function (w) { return w.trim(); })
                .filter(Boolean));
            neg.push.apply(neg, negPart
                .split(/[,，\n]/)
                .map(function (w) { return w.trim(); })
                .filter(Boolean));
            return { req: req, neg: neg };
        };
        var _b = parseConstraints(thinkingConstraints), affWords = _b.req, negWords = _b.neg;
        var _c = parseConstraints(returnConstraints), retAffWords = _c.req, retNegWords = _c.neg;
        var baseMethod = {
            method_id: methodId,
            display_name: displayName || "未命名思考方法",
            brief_desc: briefDesc,
            detail: {
                question: question,
                affirmative_words: affWords,
                negative_words: negWords,
                required_actions: requiredActions
                    .split("\n")
                    .map(function (s) { return s.trim(); })
                    .filter(Boolean),
            },
            return_format: {
                format_name: displayName || "未命名",
                format_brief: briefDesc,
                format_detail: {
                    structure: returnStructure,
                    affirmative_words: retAffWords,
                    negative_words: retNegWords,
                },
            },
        };
        // 附加脱敏字段、选择数据字段（后端可选择性使用）
        var method = __assign(__assign({}, baseMethod), { sensitive_fields: sensitiveFields, selected_data_fields: selectedDataFields });
        setLoading(true);
        var url = apiBaseUrl
            ? "".concat(apiBaseUrl.replace(/\/$/, ""), "/api/ai/update-methods")
            : "/api/ai/update-methods";
        var nextMethods = initialMethod
            ? existingMethods.map(function (m) {
                return m.method_id === initialMethod.method_id ? method : m;
            })
            : __spreadArray(__spreadArray([], existingMethods, true), [method], false);
        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: token || "",
            },
            body: JSON.stringify({
                eventHash: eventHash,
                pageId: pageId,
                thinkingMethods: nextMethods,
                token: token,
            }),
        })
            .then(function (r) { return __awaiter(_this, void 0, void 0, function () {
            var text;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!r.ok) return [3 /*break*/, 2];
                        return [4 /*yield*/, r.text().catch(function () { return ""; })];
                    case 1:
                        text = _a.sent();
                        throw new Error(text || r.statusText || "服务器返回错误");
                    case 2: return [2 /*return*/, r.json()];
                }
            });
        }); })
            .then(function () {
            message.success("思考方式已保存");
            onSaved();
            onClose();
        })
            .catch(function (e) {
            // eslint-disable-next-line no-console
            console.error("保存思考方法失败:", e);
            message.error("\u4FDD\u5B58\u601D\u8003\u65B9\u5F0F\u5931\u8D25\uFF1A".concat((e === null || e === void 0 ? void 0 : e.message) || "请稍后重试或联系后台同学检查接口"));
        })
            .finally(function () { return setLoading(false); });
    }, [
        displayName,
        briefDesc,
        question,
        thinkingConstraints,
        requiredActions,
        returnStructure,
        returnConstraints,
        sensitiveFields,
        selectedDataFields,
        eventHash,
        pageId,
        token,
        existingMethods,
        initialMethod,
        apiBaseUrl,
        onSaved,
        onClose,
    ]);
    var formItemLabelStyle = {
        fontSize: 12,
        color: "#595959",
        flexShrink: 0,
        marginBottom: 4,
    };
    var formItemWrapperStyle = {
        display: "flex",
        flexDirection: "column",
        gap: 4,
    };
    return (_jsx(Modal, __assign({ title: initialMethod ? "编辑思考方式" : "添加思考方式", open: visible, onCancel: onClose, onOk: handleSave, confirmLoading: loading, width: 1200, destroyOnClose: true, styles: {
            body: {
                padding: "24px 32px",
                height: "auto",
            },
        } }, { children: _jsxs("div", __assign({ style: {
                display: "flex",
                gap: 20,
                alignItems: "stretch",
                height: 760,
                minHeight: 760,
                maxHeight: 760,
                overflow: "hidden",
            } }, { children: [_jsxs("div", __assign({ style: {
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        gap: 12,
                        minWidth: 0,
                        minHeight: 0,
                        overflow: "hidden",
                    } }, { children: [_jsxs("div", __assign({ style: formItemWrapperStyle }, { children: [_jsxs("div", __assign({ style: formItemLabelStyle }, { children: [_jsx("span", __assign({ style: { color: "#ff4d4f", marginRight: 4 } }, { children: "*" })), "\u65B9\u6CD5\u540D\u79F0"] })), _jsx(Input, { placeholder: "\u8BF7\u8F93\u5165\u65B9\u6CD5\u540D\u79F0\uFF08\u5FC5\u586B\uFF09", value: displayName, onChange: function (e) { return setDisplayName(e.target.value); } })] })), _jsxs("div", __assign({ style: formItemWrapperStyle }, { children: [_jsx("div", __assign({ style: formItemLabelStyle }, { children: "\u7B80\u8981\u63CF\u8FF0" })), _jsx(Input.TextArea, { placeholder: "\u8BF7\u8F93\u5165\u7B80\u8981\u63CF\u8FF0", value: briefDesc, onChange: function (e) { return setBriefDesc(e.target.value); }, rows: 2 })] })), _jsxs("div", __assign({ style: {
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                minHeight: 0,
                                gap: 12,
                            } }, { children: [_jsx("div", __assign({ style: {
                                        fontWeight: 500,
                                        fontSize: 13,
                                        flexShrink: 0,
                                    } }, { children: "\u6570\u636E\u7ED3\u6784" })), _jsxs("div", __assign({ style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 8,
                                        flex: 1,
                                        minHeight: 0,
                                        borderRadius: 8,
                                        border: "1px solid #d9d9d9",
                                        background: "#fafafa",
                                        padding: 16,
                                        overflow: "hidden",
                                    } }, { children: [_jsx("div", __assign({ style: {
                                                fontWeight: 500,
                                                fontSize: 12,
                                                color: "#595959",
                                                flexShrink: 0,
                                            } }, { children: "\u4F20\u5165\u7684\u6570\u636E\u7ED3\u6784" })), _jsx("pre", __assign({ style: {
                                                margin: 0,
                                                fontSize: 11,
                                                fontFamily: "Menlo, Monaco, Consolas, monospace",
                                                lineHeight: 1.4,
                                                whiteSpace: "pre-wrap",
                                                wordBreak: "break-word",
                                                flex: 1,
                                                minHeight: 0,
                                                overflow: "auto",
                                            } }, { children: JSON.stringify(payloadStructure, null, 2) })), !samplePayload && (_jsx("div", __assign({ style: {
                                                fontSize: 11,
                                                color: "#8c8c8c",
                                                marginTop: 4,
                                                flexShrink: 0,
                                            } }, { children: "\u6682\u65E0\u70B9\u51FB\u6837\u672C\u65F6\u5C55\u793A\u9ED8\u8BA4\u5B8C\u6574\u7ED3\u6784\uFF08\u4EF7\u683C\u5EFA\u8BAE/\u623F\u6001\uFF09" })))] }))] }))] })), _jsxs("div", __assign({ style: {
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        gap: 12,
                        minWidth: 0,
                        borderLeft: "1px solid #f0f0f0",
                        borderRight: "1px solid #f0f0f0",
                        paddingLeft: 20,
                        paddingRight: 20,
                    } }, { children: [_jsxs("div", __assign({ style: formItemWrapperStyle }, { children: [_jsxs("div", __assign({ style: formItemLabelStyle }, { children: [_jsx("span", __assign({ style: { color: "#ff4d4f", marginRight: 4 } }, { children: "*" })), "\u6838\u5FC3\u95EE\u9898"] })), _jsx(Input.TextArea, { placeholder: "\u8BF7\u8F93\u5165\u8BA9 AI \u89E3\u51B3\u7684\u6838\u5FC3\u95EE\u9898\uFF08\u5FC5\u586B\uFF09", value: question, onChange: function (e) { return setQuestion(e.target.value); }, rows: 17 })] })), _jsxs("div", __assign({ style: formItemWrapperStyle }, { children: [_jsx("div", __assign({ style: formItemLabelStyle }, { children: "\u601D\u7EF4\u8981\u6C42\u4E0E\u7981\u6B62" })), _jsx(Input.TextArea, { placeholder: "要求：判断、区分、对比…（逗号分隔）\n禁止：猜测、一刀切、无依据…（逗号分隔）", value: thinkingConstraints, onChange: function (e) { return setThinkingConstraints(e.target.value); }, rows: 5 })] })), _jsxs("div", __assign({ style: formItemWrapperStyle }, { children: [_jsx("div", __assign({ style: formItemLabelStyle }, { children: "\u5FC5\u505A\u64CD\u4F5C" })), _jsx(Input.TextArea, { placeholder: "例如：\n1. 提取 amountList 字段\n2. 累加所有数字", value: requiredActions, onChange: function (e) { return setRequiredActions(e.target.value); }, rows: 6 })] })), !samplePayload && (_jsxs("div", __assign({ style: formItemWrapperStyle }, { children: [_jsx("div", __assign({ style: formItemLabelStyle }, { children: "\u9009\u62E9\u6570\u636E\u96C6" })), _jsx(Select, { placeholder: "\u8BF7\u9009\u62E9\u6570\u636E\u96C6", value: selectedDataset || undefined, onChange: setSelectedDataset, style: { width: "100%" }, options: datasets.map(function (d) { return ({
                                        label: d.dataset_name,
                                        value: d.dataset_id,
                                    }); }) })] })))] })), _jsxs("div", __assign({ style: {
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        gap: 12,
                        minWidth: 0,
                    } }, { children: [effectiveDataFields.length > 0 && (_jsxs("div", __assign({ style: formItemWrapperStyle }, { children: [_jsx("div", __assign({ style: formItemLabelStyle }, { children: "\u9009\u62E9\u6570\u636E" })), _jsx(Select, { mode: "multiple", allowClear: true, placeholder: "\u8BF7\u9009\u62E9\u8981\u53C2\u4E0E\u5206\u6790\u7684\u5B57\u6BB5", value: selectedDataFields, onChange: function (values) { return setSelectedDataFields(values); }, style: { width: "100%" }, options: effectiveDataFields.map(function (field) { return ({
                                        label: field,
                                        value: field,
                                    }); }) })] }))), _jsxs("div", __assign({ style: formItemWrapperStyle }, { children: [_jsx("div", __assign({ style: formItemLabelStyle }, { children: "\u8131\u654F\u5B57\u6BB5" })), _jsx(Select, { mode: "multiple", allowClear: true, placeholder: "\u9009\u62E9\u9700\u8981\u8131\u654F\u7684\u5B57\u6BB5", value: sensitiveFields, onChange: function (values) { return setSensitiveFields(values); }, style: { width: "100%" }, options: effectiveDataFields.map(function (field) { return ({
                                        label: field,
                                        value: field,
                                    }); }) })] })), _jsxs("div", __assign({ style: formItemWrapperStyle }, { children: [_jsx("div", __assign({ style: formItemLabelStyle }, { children: "\u8FD4\u56DE\u683C\u5F0F\u7ED3\u6784" })), _jsx(Input.TextArea, { placeholder: "\u4F8B\u5982\uFF1A\u623F\u578B:\u5F53\u524D\u4EF7,\u5EFA\u8BAE\u4EF7,\u7406\u7531", value: returnStructure, onChange: function (e) { return setReturnStructure(e.target.value); }, rows: 12 })] })), _jsxs("div", __assign({ style: formItemWrapperStyle }, { children: [_jsx("div", __assign({ style: formItemLabelStyle }, { children: "\u8FD4\u56DE\u683C\u5F0F\u8981\u6C42\u4E0E\u7981\u6B62" })), _jsx(Input.TextArea, { placeholder: "要求：具体数值、明确理由…（逗号分隔）\n禁止：模糊表述、无依据…（逗号分隔）", value: returnConstraints, onChange: function (e) { return setReturnConstraints(e.target.value); }, rows: 5 })] }))] }))] })) })));
}
/**
 * CompsAi 组件
 * 只负责显示和选择，不负责AI调用
 * AI调用由上层通过hook处理
 *
 * 新设计（apiBaseUrl + onResult + ref）：通过 ref.receiveMessage(msg) 发送 StandardAiComponentMessage，
 * 内部走 get-thinking-methods / get-cache / save-cache / call-model 统一接口，结果由 onResult 回调。
 *
 * 上半部分：以树形结构展示多层数据（支持任意层级）
 * 下半部分：AI返回的消息列表
 */
var CompsAiInner = function (_a, ref) {
    var _b, _c, _d, _e, _f, _g, _h;
    var treeData = _a.treeData, onNodeClick = _a.onNodeClick, onThinkingModeClick = _a.onThinkingModeClick, aiMessagesProp = _a.aiMessages, loadingProp = _a.loading, _j = _a.title, title = _j === void 0 ? "AI 助手" : _j, style = _a.style, _k = _a.height, height = _k === void 0 ? "100%" : _k, onClearMessages = _a.onClearMessages, onClearAll = _a.onClearAll, onSettingsClick = _a.onSettingsClick, _l = _a.defaultExpandAll, defaultExpandAll = _l === void 0 ? true : _l, renderNodeTitle = _a.renderNodeTitle, apiBaseUrl = _a.apiBaseUrl, onResult = _a.onResult, 
    // 旧接口兼容属性
    dataSource = _a.dataSource, thinkingModes = _a.thinkingModes, onFetchData = _a.onFetchData, onSelectionChange = _a.onSelectionChange, 
    // 新设计：从数据库获取思考模式
    pageId = _a.pageId, microServiceId = _a.microServiceId, configApiBaseUrl = _a.configApiBaseUrl, skipPageConfigLoad = _a.skipPageConfigLoad, 
    // 三部分之「可选择的思考方式」：是否可编辑、添加/编辑回调
    _m = _a.editable, 
    // 三部分之「可选择的思考方式」：是否可编辑、添加/编辑回调
    editable = _m === void 0 ? false : _m, onAddThinkingMode = _a.onAddThinkingMode, onEditThinkingMode = _a.onEditThinkingMode;
    // ==================== 新设计：AI 结果展示（受控 / 非受控） ====================
    // - 触发动作：ref.receiveMessage(msg)
    // - 展示状态：优先使用外部传入的 aiMessages/loading；未传时由组件内部维护
    var _o = useState([]), innerAiMessages = _o[0], setInnerAiMessages = _o[1];
    var _p = useState(false), innerLoading = _p[0], setInnerLoading = _p[1];
    var aiMessages = aiMessagesProp !== null && aiMessagesProp !== void 0 ? aiMessagesProp : innerAiMessages;
    var loading = loadingProp !== null && loadingProp !== void 0 ? loadingProp : innerLoading;
    // 新设计：用于「传入的信息」区域展示最近一次消息
    var _q = useState(null), lastIncomingMessage = _q[0], setLastIncomingMessage = _q[1];
    // 用 ref 存一份最新消息，点击思考方式时用 ref 保证拿到带完整 payload 的消息（避免 state 未刷新导致只传结构不传数据）
    var lastIncomingMessageRef = useRef(null);
    // 用于 ref.clearSelection：切换组件/门店时先清理选择状态
    var clearSelectionFnRef = useRef(function () { });
    // 「传入的信息」编辑：允许基于最近一次消息编辑 payload
    var _r = useState(null), editedPayloadOverride = _r[0], setEditedPayloadOverride = _r[1];
    var _s = useState(false), editPayloadModalVisible = _s[0], setEditPayloadModalVisible = _s[1];
    var _t = useState(false), editPayloadSaving = _t[0], setEditPayloadSaving = _t[1];
    var editPayloadFormRef = useRef(null);
    // 新设计：从数据库查询到的思考方法（基于 lastIncomingMessage）
    var _u = useState([]), fetchedThinkingModes = _u[0], setFetchedThinkingModes = _u[1];
    // 新设计：根据传参显示的组件名称（来自 get-component-info 或 payload.metadata.label）
    var _v = useState(""), displayComponentName = _v[0], setDisplayComponentName = _v[1];
    // 记录当前展示名称对应的组件（同一组件再次点击时不拿 payload 英文覆盖已取得的中文名）
    var displayNameComponentKeyRef = useRef(null);
    // 当前组件对应的事件是否已在后端存在（用于控制是否允许添加思考方式）
    var _w = useState(false), hasExistingEventForComponent = _w[0], setHasExistingEventForComponent = _w[1];
    // 添加/编辑思考方式对话框
    var _x = useState(false), addThinkingMethodDialogVisible = _x[0], setAddThinkingMethodDialogVisible = _x[1];
    var _y = useState(null), editingThinkingMethod = _y[0], setEditingThinkingMethod = _y[1];
    // 当前 eventHash（用于添加思考方式保存到数据库）
    var _z = useState(""), currentEventHashForDialog = _z[0], setCurrentEventHashForDialog = _z[1];
    // 当前页面的完整思考方法列表（后端格式，用于 update-methods 追加）
    var _0 = useState([]), currentBackendThinkingMethods = _0[0], setCurrentBackendThinkingMethods = _0[1];
    // 计算用于展示/编辑的 payload：优先使用用户编辑后的内容
    var effectivePayloadForDisplay = useMemo(function () {
        var _a, _b;
        return ((_b = editedPayloadOverride !== null && editedPayloadOverride !== void 0 ? editedPayloadOverride : (_a = lastIncomingMessage === null || lastIncomingMessage === void 0 ? void 0 : lastIncomingMessage.eventData) === null || _a === void 0 ? void 0 : _a.payload) !== null && _b !== void 0 ? _b : null);
    }, [editedPayloadOverride, lastIncomingMessage]);
    // 打开「编辑传入的数据」对话框时，初始化名称、说明和 JSON 文本
    var openEditPayloadModal = useCallback(function () {
        if (!lastIncomingMessage)
            return;
        setEditPayloadModalVisible(true);
    }, [lastIncomingMessage]);
    // 当收到新的消息时，如果还没有用户自定义覆盖，则重置编辑覆盖
    useEffect(function () {
        if (!lastIncomingMessage) {
            setEditedPayloadOverride(null);
            setHasExistingEventForComponent(false);
            return;
        }
    }, [lastIncomingMessage, editedPayloadOverride]);
    // 根据传参从接口获取组件名称并显示（get-component-info）
    useEffect(function () {
        var _a, _b;
        var msg = lastIncomingMessage;
        if (!((_a = msg === null || msg === void 0 ? void 0 : msg.source) === null || _a === void 0 ? void 0 : _a.pageId) ||
            !((_b = msg === null || msg === void 0 ? void 0 : msg.source) === null || _b === void 0 ? void 0 : _b.componentId) ||
            !pageId ||
            !microServiceId)
            return;
        var baseUrl = configApiBaseUrl || apiBaseUrl || "";
        var apiUrl = baseUrl
            ? "".concat(baseUrl, "/api/ai/get-component-info")
            : "/api/ai/get-component-info";
        axios
            .get(apiUrl, {
            params: {
                pageId: msg.source.pageId,
                componentId: msg.source.componentId,
            },
        })
            .then(function (res) {
            var _a, _b;
            var data = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data;
            var name = data === null || data === void 0 ? void 0 : data.component_name;
            var backendEventHash = data === null || data === void 0 ? void 0 : data.event_hash;
            if (name) {
                setDisplayComponentName(name);
                setHasExistingEventForComponent(true);
            }
            else {
                setHasExistingEventForComponent(false);
            }
            if (backendEventHash && typeof backendEventHash === "string") {
                setCurrentEventHashForDialog(backendEventHash);
                var methodsUrl = baseUrl
                    ? "".concat(baseUrl.replace(/\/$/, ""), "/api/ai/get-thinking-methods")
                    : "/api/ai/get-thinking-methods";
                var methodsApiUrl = "".concat(methodsUrl, "?eventHash=").concat(encodeURIComponent(backendEventHash), "&pageId=").concat(encodeURIComponent(msg.source.pageId));
                axios
                    .get(methodsApiUrl, {
                    headers: {
                        Authorization: ((_b = msg.context) === null || _b === void 0 ? void 0 : _b.token) || "",
                    },
                })
                    .then(function (methodsRes) {
                    var _a;
                    var arr = Array.isArray((_a = methodsRes === null || methodsRes === void 0 ? void 0 : methodsRes.data) === null || _a === void 0 ? void 0 : _a.data)
                        ? methodsRes.data.data
                        : [];
                    setFetchedThinkingModes(arr.map(function (m) { return ({
                        id: m.method_id || m.id,
                        label: m.display_name || m.label || m.method_id || m.id,
                        description: m.brief_desc || m.description || "",
                    }); }));
                    setCurrentBackendThinkingMethods(arr);
                })
                    .catch(function () {
                    setFetchedThinkingModes([]);
                });
            }
        })
            .catch(function () {
            setHasExistingEventForComponent(false);
        });
    }, [
        (_b = lastIncomingMessage === null || lastIncomingMessage === void 0 ? void 0 : lastIncomingMessage.source) === null || _b === void 0 ? void 0 : _b.pageId,
        (_c = lastIncomingMessage === null || lastIncomingMessage === void 0 ? void 0 : lastIncomingMessage.source) === null || _c === void 0 ? void 0 : _c.componentId,
        (_d = lastIncomingMessage === null || lastIncomingMessage === void 0 ? void 0 : lastIncomingMessage.context) === null || _d === void 0 ? void 0 : _d.token,
        pageId,
        microServiceId,
        configApiBaseUrl,
        apiBaseUrl,
    ]);
    var _1 = useAiComponentHook({
        apiBaseUrl: apiBaseUrl !== null && apiBaseUrl !== void 0 ? apiBaseUrl : "",
        fetchFn: typeof fetch !== "undefined" ? fetch : undefined,
    }), handleIncomingMessage = _1.handleIncomingMessage, generateEventHash = _1.generateEventHash;
    useImperativeHandle(ref, function () { return ({
        clearSelection: function () {
            var _a;
            (_a = clearSelectionFnRef.current) === null || _a === void 0 ? void 0 : _a.call(clearSelectionFnRef);
        },
        receiveMessage: function (msg) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            return __awaiter(this, void 0, void 0, function () {
                var componentKey, labelFromPayload, structuredPayload, eventContentStr, eventHash, baseUrl, fetchFn, updateInfoUrl, updateRes, updateJson, backendEventHash, _q, apiPath, apiUrl, thinkingMethodsRes, thinkingMethodsJson, thinkingMethods, infoUrl, infoQuery, infoRes, infoJson, componentName, _r, err_1;
                return __generator(this, function (_s) {
                    switch (_s.label) {
                        case 0:
                            // 记录最近一次输入，供 UI 展示（不依赖 treeData）
                            setLastIncomingMessage(msg);
                            lastIncomingMessageRef.current = msg;
                            // 收到新消息时，清空用户自定义编辑内容，避免残留
                            setEditedPayloadOverride(null);
                            componentKey = "".concat((_b = (_a = msg.source) === null || _a === void 0 ? void 0 : _a.pageId) !== null && _b !== void 0 ? _b : "", ":").concat((_d = (_c = msg.source) === null || _c === void 0 ? void 0 : _c.componentId) !== null && _d !== void 0 ? _d : "");
                            displayNameComponentKeyRef.current = componentKey;
                            labelFromPayload = ((_g = (_f = (_e = msg.eventData) === null || _e === void 0 ? void 0 : _e.payload) === null || _f === void 0 ? void 0 : _f.metadata) === null || _g === void 0 ? void 0 : _g.label) ||
                                ((_j = (_h = msg.eventData) === null || _h === void 0 ? void 0 : _h.payload) === null || _j === void 0 ? void 0 : _j.componentType) ||
                                msg.source.componentId;
                            if (labelFromPayload && String(labelFromPayload).trim()) {
                                setDisplayComponentName(String(labelFromPayload).trim());
                            }
                            console.log("📨 [CompsAi] 通过 ref.receiveMessage 接收消息:", {
                                msgId: msg.msgId,
                                source: {
                                    microServiceId: msg.source.microServiceId,
                                    pageId: msg.source.pageId,
                                    componentId: msg.source.componentId,
                                    componentType: msg.source.componentType,
                                },
                                eventData: {
                                    eventType: msg.eventData.eventType,
                                    triggerTime: msg.eventData.triggerTime,
                                    payloadKeys: Object.keys(msg.eventData.payload || {}),
                                    payloadSize: JSON.stringify(msg.eventData.payload || {}).length,
                                },
                                hasContext: !!msg.context,
                                context: msg.context
                                    ? {
                                        userId: msg.context.userId,
                                        hasToken: !!msg.context.token,
                                    }
                                    : null,
                                fullMessage: msg,
                            });
                            _s.label = 1;
                        case 1:
                            _s.trys.push([1, 19, , 20]);
                            structuredPayload = getPayloadStructure(msg.eventData.payload);
                            eventContentStr = JSON.stringify(structuredPayload);
                            return [4 /*yield*/, generateEventHash(eventContentStr)];
                        case 2:
                            eventHash = _s.sent();
                            baseUrl = apiBaseUrl !== null && apiBaseUrl !== void 0 ? apiBaseUrl : "";
                            fetchFn = typeof fetch !== "undefined" ? fetch : globalThis.fetch;
                            updateInfoUrl = baseUrl
                                ? "".concat(baseUrl.replace(/\/$/, ""), "/api/ai/update-component-info")
                                : "/api/ai/update-component-info";
                            _s.label = 3;
                        case 3:
                            _s.trys.push([3, 7, , 8]);
                            return [4 /*yield*/, fetchFn(updateInfoUrl, {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                        Authorization: ((_k = msg.context) === null || _k === void 0 ? void 0 : _k.token) || "",
                                    },
                                    body: JSON.stringify({
                                        pageId: msg.source.pageId,
                                        componentId: msg.source.componentId,
                                        payload: structuredPayload,
                                    }),
                                })];
                        case 4:
                            updateRes = _s.sent();
                            if (!updateRes.ok) return [3 /*break*/, 6];
                            return [4 /*yield*/, updateRes.json().catch(function () { return ({}); })];
                        case 5:
                            updateJson = _s.sent();
                            backendEventHash = (_l = updateJson === null || updateJson === void 0 ? void 0 : updateJson.data) === null || _l === void 0 ? void 0 : _l.eventHash;
                            if (typeof backendEventHash === "string" &&
                                backendEventHash.length > 0) {
                                eventHash = backendEventHash;
                            }
                            setHasExistingEventForComponent(true);
                            _s.label = 6;
                        case 6: return [3 /*break*/, 8];
                        case 7:
                            _q = _s.sent();
                            return [3 /*break*/, 8];
                        case 8:
                            setCurrentEventHashForDialog(eventHash);
                            apiPath = baseUrl
                                ? "".concat(baseUrl, "/api/ai/get-thinking-methods")
                                : "/api/ai/get-thinking-methods";
                            apiUrl = "".concat(apiPath, "?eventHash=").concat(encodeURIComponent(eventHash), "&pageId=").concat(encodeURIComponent(msg.source.pageId));
                            console.log("📡 [CompsAi] 查询思考方法（用于 UI 显示）:", {
                                url: apiUrl,
                                componentId: msg.source.componentId,
                            });
                            return [4 /*yield*/, fetchFn(apiUrl, {
                                    headers: { Authorization: ((_m = msg.context) === null || _m === void 0 ? void 0 : _m.token) || "" },
                                })];
                        case 9:
                            thinkingMethodsRes = _s.sent();
                            if (!thinkingMethodsRes.ok) return [3 /*break*/, 11];
                            return [4 /*yield*/, thinkingMethodsRes.json()];
                        case 10:
                            thinkingMethodsJson = _s.sent();
                            thinkingMethods = Array.isArray(thinkingMethodsJson === null || thinkingMethodsJson === void 0 ? void 0 : thinkingMethodsJson.data)
                                ? thinkingMethodsJson.data.map(function (m) { return ({
                                    id: m.method_id || m.id,
                                    label: m.display_name || m.label || m.method_id || m.id,
                                    description: m.brief_desc || m.description || "",
                                }); })
                                : (thinkingMethodsJson === null || thinkingMethodsJson === void 0 ? void 0 : thinkingMethodsJson.data)
                                    ? [
                                        {
                                            id: thinkingMethodsJson.data.method_id ||
                                                thinkingMethodsJson.data.id,
                                            label: thinkingMethodsJson.data.display_name ||
                                                thinkingMethodsJson.data.label ||
                                                thinkingMethodsJson.data.method_id ||
                                                thinkingMethodsJson.data.id,
                                            description: thinkingMethodsJson.data.brief_desc ||
                                                thinkingMethodsJson.data.description ||
                                                "",
                                        },
                                    ]
                                    : [];
                            console.log("✅ [CompsAi] 思考方法查询成功:", {
                                count: thinkingMethods.length,
                                methods: thinkingMethods.map(function (m) { return m.label; }),
                            });
                            setFetchedThinkingModes(thinkingMethods);
                            setCurrentBackendThinkingMethods(Array.isArray(thinkingMethodsJson === null || thinkingMethodsJson === void 0 ? void 0 : thinkingMethodsJson.data)
                                ? thinkingMethodsJson.data
                                : []);
                            return [3 /*break*/, 12];
                        case 11:
                            console.warn("⚠️ [CompsAi] 思考方法查询失败（不影响主流程）:", thinkingMethodsRes.status, thinkingMethodsRes.statusText);
                            setFetchedThinkingModes([]);
                            _s.label = 12;
                        case 12:
                            infoUrl = baseUrl
                                ? "".concat(baseUrl.replace(/\/$/, ""), "/api/ai/get-component-info")
                                : "/api/ai/get-component-info";
                            infoQuery = "pageId=".concat(encodeURIComponent(msg.source.pageId), "&componentId=").concat(encodeURIComponent(msg.source.componentId));
                            _s.label = 13;
                        case 13:
                            _s.trys.push([13, 17, , 18]);
                            return [4 /*yield*/, fetchFn("".concat(infoUrl, "?").concat(infoQuery), {
                                    headers: { Authorization: ((_o = msg.context) === null || _o === void 0 ? void 0 : _o.token) || "" },
                                })];
                        case 14:
                            infoRes = _s.sent();
                            if (!infoRes.ok) return [3 /*break*/, 16];
                            return [4 /*yield*/, infoRes.json().catch(function () { return ({}); })];
                        case 15:
                            infoJson = _s.sent();
                            componentName = (_p = infoJson === null || infoJson === void 0 ? void 0 : infoJson.data) === null || _p === void 0 ? void 0 : _p.component_name;
                            if (typeof componentName === "string" &&
                                componentName.trim().length > 0) {
                                setDisplayComponentName(componentName.trim());
                            }
                            _s.label = 16;
                        case 16: return [3 /*break*/, 18];
                        case 17:
                            _r = _s.sent();
                            return [3 /*break*/, 18];
                        case 18: return [3 /*break*/, 20];
                        case 19:
                            err_1 = _s.sent();
                            console.warn("⚠️ [CompsAi] 思考方法查询异常（不影响主流程）:", err_1);
                            setFetchedThinkingModes([]);
                            return [3 /*break*/, 20];
                        case 20: return [2 /*return*/];
                    }
                });
            });
        },
    }); }, [
        handleIncomingMessage,
        generateEventHash,
        onResult,
        aiMessagesProp,
        loadingProp,
        apiBaseUrl,
    ]);
    // 页面配置缓存（用于获取思考模式）
    var _2 = useState(null), pageConfigCache = _2[0], setPageConfigCache = _2[1];
    var _3 = useState(false), pageConfigLoading = _3[0], setPageConfigLoading = _3[1];
    // 加载页面配置（旧设计：从 config/page 取思考模式；新设计下可跳过，思考方式来自 get-thinking-methods）
    useEffect(function () {
        if (skipPageConfigLoad ||
            !pageId ||
            !microServiceId ||
            pageConfigCache ||
            pageConfigLoading) {
            return;
        }
        setPageConfigLoading(true);
        var baseUrl = configApiBaseUrl || apiBaseUrl || "";
        var apiUrl = baseUrl
            ? "".concat(baseUrl, "/api/ai/config/page")
            : "/api/ai/config/page"; // 使用相对路径，走代理
        console.log("📡 [CompsAi] 开始加载页面配置:", {
            pageId: pageId,
            microServiceId: microServiceId,
            apiUrl: apiUrl,
        });
        axios
            .get(apiUrl, {
            params: {
                service_name: microServiceId,
                page_id: pageId,
            },
        })
            .then(function (response) {
            if (response.data.code === 200) {
                console.log("✅ [CompsAi] 页面配置加载成功:", response.data.data);
                setPageConfigCache(response.data.data);
            }
            else {
                console.warn("⚠️ [CompsAi] 页面配置加载失败:", response.data.message);
            }
        })
            .catch(function (error) {
            console.error("❌ [CompsAi] 页面配置加载失败:", error);
        })
            .finally(function () {
            setPageConfigLoading(false);
        });
    }, [
        skipPageConfigLoad,
        pageId,
        microServiceId,
        configApiBaseUrl,
        apiBaseUrl,
        pageConfigCache,
        pageConfigLoading,
    ]);
    // 根据 componentId 获取思考模式
    var getThinkingModesForComponent = useCallback(function (componentId) {
        var _a;
        if (!pageConfigCache || !componentId) {
            return [];
        }
        var component = (_a = pageConfigCache.components) === null || _a === void 0 ? void 0 : _a.find(function (c) { return c.componentId === componentId; });
        if (!component ||
            !component.thinkingModes ||
            component.thinkingModes.length === 0) {
            return [];
        }
        return component.thinkingModes
            .sort(function (a, b) { return (a.sortOrder || 0) - (b.sortOrder || 0); })
            .map(function (mode) { return ({
            id: mode.thinkingModeId || mode.id,
            label: mode.label || mode.thinkingModeId || mode.id,
            description: mode.description || "",
        }); });
    }, [pageConfigCache]);
    // 递归处理树节点，为每个包含 componentId 的节点添加思考模式子节点
    var enrichTreeDataWithThinkingModes = useCallback(function (nodes) {
        return nodes.map(function (node) {
            var _a;
            var enrichedNode = __assign({}, node);
            // 如果节点有 componentId，尝试获取思考模式
            if (node.componentId && pageId && microServiceId) {
                var thinkingModes_1 = getThinkingModesForComponent(node.componentId);
                if (thinkingModes_1.length > 0) {
                    // 如果节点还没有 children，或者 children 中没有思考模式节点，则添加
                    var hasThinkingChildren = (_a = enrichedNode.children) === null || _a === void 0 ? void 0 : _a.some(function (child) { return child.type === "thinking"; });
                    if (!hasThinkingChildren) {
                        var thinkingChildren = thinkingModes_1.map(function (mode) { return ({
                            id: "".concat(enrichedNode.id, "-").concat(mode.id),
                            label: mode.label,
                            type: "thinking",
                            description: mode.description,
                            thinkingMode: mode,
                            data: enrichedNode.data, // 继承父节点的数据
                        }); });
                        enrichedNode.children = __spreadArray(__spreadArray([], (enrichedNode.children || []), true), thinkingChildren, true);
                    }
                }
            }
            // 递归处理子节点
            if (enrichedNode.children && enrichedNode.children.length > 0) {
                enrichedNode.children = enrichTreeDataWithThinkingModes(enrichedNode.children);
            }
            return enrichedNode;
        });
    }, [pageId, microServiceId, getThinkingModesForComponent]);
    // 将旧接口（dataSource + thinkingModes）转换为 treeData
    var convertedTreeData = useMemo(function () {
        var hasTreeData = !!treeData && Array.isArray(treeData) && treeData.length > 0;
        var hasDataSource = !!dataSource && Array.isArray(dataSource) && dataSource.length > 0;
        // 无 treeData 且无 dataSource 时直接返回空数组，不打印日志（如 store-revenue-monitor 初始未传为合法场景）
        if (!hasTreeData && !hasDataSource) {
            return [];
        }
        if (process.env.NODE_ENV === "development") {
            console.log("🔄 [CompsAi] 转换 treeData:", {
                hasTreeData: hasTreeData,
                hasDataSource: hasDataSource,
                hasThinkingModes: !!thinkingModes &&
                    Array.isArray(thinkingModes) &&
                    thinkingModes.length > 0,
                hasPageConfig: !!pageConfigCache,
                pageId: pageId,
                microServiceId: microServiceId,
            });
        }
        // 如果提供了 treeData，优先使用 treeData
        if (treeData && Array.isArray(treeData) && treeData.length > 0) {
            var result = treeData;
            // 如果提供了 pageId 和 microServiceId，并且页面配置已加载，则动态添加思考模式
            if (pageId && microServiceId && pageConfigCache) {
                console.log("✅ [CompsAi] 使用 treeData 并动态添加思考模式");
                result = enrichTreeDataWithThinkingModes(treeData);
            }
            else {
                console.log("✅ [CompsAi] 使用 treeData，节点数量:", treeData.length);
            }
            return result;
        }
        // 否则，尝试从 dataSource 和 thinkingModes 构建 treeData
        if (dataSource && Array.isArray(dataSource) && dataSource.length > 0) {
            var safeThinkingModes_1 = thinkingModes &&
                Array.isArray(thinkingModes) &&
                thinkingModes.length > 0
                ? thinkingModes
                : [];
            console.log("✅ [CompsAi] 从 dataSource 构建 treeData:", {
                dataSourceCount: dataSource.length,
                thinkingModesCount: safeThinkingModes_1.length,
            });
            return dataSource.map(function (item) {
                var dataNode = {
                    id: item.id,
                    label: item.label,
                    type: "data",
                    data: item.value,
                    children: safeThinkingModes_1.length > 0
                        ? safeThinkingModes_1.map(function (mode) { return ({
                            id: "".concat(item.id, "-").concat(mode.id),
                            label: mode.label,
                            type: "thinking",
                            description: mode.description,
                            thinkingMode: mode,
                            data: item.value,
                        }); })
                        : undefined,
                };
                return dataNode;
            });
        }
        // 理论上不会走到这里（无数据已在开头提前 return []）
        return [];
    }, [
        treeData,
        dataSource,
        thinkingModes,
        pageConfigCache,
        pageId,
        microServiceId,
        enrichTreeDataWithThinkingModes,
    ]);
    // 根据节点类型获取默认图标
    var getNodeIcon = function (node) {
        if (node.icon) {
            return node.icon;
        }
        if (node.type === "data") {
            return _jsx(DatabaseOutlined, { style: { fontSize: 16, color: "#1890ff" } });
        }
        if (node.type === "thinking") {
            return _jsx(ThunderboltOutlined, { style: { fontSize: 14, color: "#52c41a" } });
        }
        // 默认图标
        return _jsx(DatabaseOutlined, { style: { fontSize: 14, color: "#666" } });
    };
    // 递归构建 Ant Design Tree 数据格式
    var buildTreeData = function (nodes, path) {
        if (path === void 0) { path = []; }
        return nodes.map(function (node) {
            var currentPath = __spreadArray(__spreadArray([], path, true), [node], false);
            // 使用自定义渲染函数或默认渲染
            var title = renderNodeTitle ? (renderNodeTitle(node)) : (_jsxs(Space, __assign({ style: { width: "100%" } }, { children: [node.type !== "thinking" && getNodeIcon(node), node.type !== "thinking" && (_jsx(Text, __assign({ style: { fontSize: node.type === "data" ? 16 : 14 } }, { children: node.label }))), node.description && (_jsx(Text, __assign({ style: { fontSize: 12, color: "#666" } }, { children: node.description }))), node.type === "thinking" && getNodeIcon(node)] })));
            var treeNode = {
                title: title,
                key: node.id,
                treeNode: node,
                path: currentPath, // 保存路径信息
            };
            // 递归处理子节点
            // 确保创建新的数组引用，避免数据累积
            if (node.children &&
                Array.isArray(node.children) &&
                node.children.length > 0) {
                treeNode.children = buildTreeData(__spreadArray([], node.children, true), currentPath);
            }
            else {
                // 明确设置为 undefined，避免残留的子节点
                treeNode.children = undefined;
            }
            return treeNode;
        });
    };
    // 构建树形数据
    // 过滤掉顶层的独立思考方式节点（只显示有数据关联的节点）
    var antdTreeData = useMemo(function () {
        // 检查 convertedTreeData 是否存在且为数组
        if (!convertedTreeData ||
            !Array.isArray(convertedTreeData) ||
            convertedTreeData.length === 0) {
            return [];
        }
        // 过滤掉顶层的思考方式节点（type === 'thinking'）
        // 思考方式节点应该只作为数据节点的子节点显示，不应该出现在顶层
        var filteredTreeData = convertedTreeData.filter(function (node) {
            // 只保留数据节点（type === 'data'），过滤掉所有顶层的思考方式节点
            return node.type !== "thinking";
        });
        // 每次构建时都从全新的数据构建，避免数据累积
        return buildTreeData(filteredTreeData);
    }, [convertedTreeData, renderNodeTitle]);
    // 生成树组件的 key，基于数据内容的哈希，确保数据变化时组件重新渲染
    var treeKey = antdTreeData.length === 0
        ? "empty-tree"
        : antdTreeData.map(function (node) { return node.key; }).join("-");
    // 树形结构的选择状态管理
    var _4 = useState([]), selectedKeys = _4[0], setSelectedKeys = _4[1];
    // 当前选择的信息（用于清理）
    var _5 = useState(null), currentSelection = _5[0], setCurrentSelection = _5[1];
    // 当 treeData 变为空时，自动清理选择状态
    useEffect(function () {
        if (!convertedTreeData || convertedTreeData.length === 0) {
            setSelectedKeys([]);
            setCurrentSelection(null);
        }
    }, [convertedTreeData]);
    // 切换组件/门店时清理选择状态（由 ref.clearSelection 调用）
    // 注意：不清空 setFetchedThinkingModes，避免在 receiveMessage 异步拉取新思考方式前出现空白；新数据会覆盖
    var handleClearSelection = useCallback(function () {
        setSelectedKeys([]);
        setCurrentSelection(null);
        setLastIncomingMessage(null);
        lastIncomingMessageRef.current = null;
        setEditedPayloadOverride(null);
        setDisplayComponentName("");
        displayNameComponentKeyRef.current = null;
        setCurrentEventHashForDialog("");
        setCurrentBackendThinkingMethods([]);
        if (aiMessagesProp === undefined)
            setInnerAiMessages([]);
        if (loadingProp === undefined)
            setInnerLoading(false);
    }, [aiMessagesProp, loadingProp]);
    useEffect(function () {
        clearSelectionFnRef.current = handleClearSelection;
        return function () {
            clearSelectionFnRef.current = function () { };
        };
    }, [handleClearSelection]);
    // 第二部分「可选择的思考方式」所用列表：
    // 新设计：优先使用从数据库查询的思考方法（基于 lastIncomingMessage）
    // 旧设计：从树节点或页面配置中获取
    // 仅有在用户已选择/点击组件（有 lastIncomingMessage 或树选择）时才展示思考方式
    var currentThinkingModesForPart2 = useMemo(function () {
        var _a, _b;
        var hasContext = lastIncomingMessage || ((_a = convertedTreeData === null || convertedTreeData === void 0 ? void 0 : convertedTreeData.length) !== null && _a !== void 0 ? _a : 0) > 0;
        if (!hasContext) {
            return [];
        }
        // 新设计：如果有从数据库查询到的思考方法，优先使用
        if (fetchedThinkingModes.length > 0) {
            return fetchedThinkingModes;
        }
        // 旧设计：从树节点或页面配置中获取
        var path = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.path;
        var dataNode = (path === null || path === void 0 ? void 0 : path.length)
            ? __spreadArray([], path, true).reverse().find(function (n) { return n.type === "data"; })
            : convertedTreeData === null || convertedTreeData === void 0 ? void 0 : convertedTreeData[0];
        var node = (_b = dataNode) !== null && _b !== void 0 ? _b : convertedTreeData === null || convertedTreeData === void 0 ? void 0 : convertedTreeData[0];
        var cid = node && "componentId" in node
            ? node.componentId
            : lastIncomingMessage === null || lastIncomingMessage === void 0 ? void 0 : lastIncomingMessage.source.componentId; // 新设计：如果没有树节点，尝试从 lastIncomingMessage 获取
        if (cid && getThinkingModesForComponent) {
            return getThinkingModesForComponent(cid);
        }
        if (thinkingModes &&
            Array.isArray(thinkingModes) &&
            thinkingModes.length > 0) {
            return thinkingModes;
        }
        return [];
    }, [
        lastIncomingMessage,
        convertedTreeData,
        fetchedThinkingModes,
        currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.path,
        getThinkingModesForComponent,
        thinkingModes,
        lastIncomingMessage === null || lastIncomingMessage === void 0 ? void 0 : lastIncomingMessage.source.componentId,
    ]);
    // 处理树节点点击
    var handleTreeSelect = function (selectedKeys, info) { return __awaiter(void 0, void 0, void 0, function () {
        var node, path, dataSourceItem, selectedData, error_1;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    console.log("🖱️ [CompsAi] 树节点点击:", {
                        selectedKeys: selectedKeys,
                        nodeInfo: {
                            id: (_a = info.node) === null || _a === void 0 ? void 0 : _a.key,
                            title: (_b = info.node) === null || _b === void 0 ? void 0 : _b.title,
                            hasTreeNode: !!((_c = info.node) === null || _c === void 0 ? void 0 : _c.treeNode),
                            hasPath: !!((_d = info.node) === null || _d === void 0 ? void 0 : _d.path),
                            pathLength: ((_f = (_e = info.node) === null || _e === void 0 ? void 0 : _e.path) === null || _f === void 0 ? void 0 : _f.length) || 0,
                        },
                        fullInfo: info,
                    });
                    // 更新选择状态
                    setSelectedKeys(selectedKeys);
                    node = info.node.treeNode;
                    path = info.node.path || [node];
                    if (!node) {
                        console.warn("⚠️ [CompsAi] 节点为空，无法处理点击");
                        return [2 /*return*/];
                    }
                    console.log("📋 [CompsAi] 解析后的节点信息:", {
                        node: {
                            id: node.id,
                            label: node.label,
                            type: node.type,
                            hasData: !!node.data,
                            hasThinkingMode: !!node.thinkingMode,
                            thinkingModeId: (_g = node.thinkingMode) === null || _g === void 0 ? void 0 : _g.id,
                            hasChildren: !!node.children,
                            childrenCount: ((_h = node.children) === null || _h === void 0 ? void 0 : _h.length) || 0,
                        },
                        path: path.map(function (p) { return ({
                            id: p.id,
                            label: p.label,
                            type: p.type,
                        }); }),
                    });
                    if (!(node.type === "thinking" &&
                        node.thinkingMode &&
                        onSelectionChange &&
                        onFetchData)) return [3 /*break*/, 5];
                    dataSourceItem = dataSource === null || dataSource === void 0 ? void 0 : dataSource.find(function (item) {
                        // 通过路径找到数据节点
                        var dataNode = path.find(function (n) { return n.type === "data"; });
                        return (dataNode && (item.id === dataNode.id || item.label === dataNode.label));
                    });
                    if (!dataSourceItem) return [3 /*break*/, 4];
                    _k.label = 1;
                case 1:
                    _k.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, onFetchData(dataSourceItem)];
                case 2:
                    selectedData = _k.sent();
                    // 调用旧接口的回调
                    onSelectionChange({
                        dataSourceItem: dataSourceItem,
                        selectedData: selectedData,
                        thinkingMode: node.thinkingMode,
                        selectedFields: [],
                    });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _k.sent();
                    console.error("获取数据失败:", error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
                case 5:
                    // 保存当前选择信息（用于清理）
                    setCurrentSelection({
                        nodeId: node.id,
                        path: path,
                        thinkingMode: node.thinkingMode,
                    });
                    // 优先使用 onNodeClick
                    if (onNodeClick) {
                        console.log("📤 [CompsAi] 调用 onNodeClick 回调:", {
                            nodeId: node.id,
                            nodeLabel: node.label,
                            nodeType: node.type,
                            thinkingModeId: (_j = node.thinkingMode) === null || _j === void 0 ? void 0 : _j.id,
                            pathLength: path.length,
                            hasData: !!node.data,
                            params: {
                                node: node,
                                path: path,
                                data: node.data,
                                thinkingMode: node.thinkingMode,
                            },
                        });
                        onNodeClick({
                            node: node,
                            path: path,
                            data: node.data,
                            thinkingMode: node.thinkingMode,
                        });
                    }
                    else if (onThinkingModeClick && node.thinkingMode) {
                        // 向后兼容：如果是思考方式节点，调用旧的回调
                        console.log("📤 [CompsAi] 调用 onThinkingModeClick 回调（向后兼容）:", {
                            thinkingModeId: node.thinkingMode.id,
                            thinkingModeLabel: node.thinkingMode.label,
                            hasData: !!node.data,
                            params: {
                                data: node.data,
                                thinkingMode: node.thinkingMode,
                                node: node,
                                path: path,
                            },
                        });
                        onThinkingModeClick({
                            data: node.data,
                            thinkingMode: node.thinkingMode,
                            node: node,
                            path: path,
                        });
                    }
                    else {
                        console.warn("⚠️ [CompsAi] 没有提供 onNodeClick 或 onThinkingModeClick 回调");
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    // 第二部分「思考方式」点击时：
    // 1）如果有树选择，则通过回调把数据 + 思考方式抛给外部；
    // 2）只要有最近一次消息，就调用 AI（handleIncomingMessage），将结果写入反馈结果。
    var handlePart2ThinkingModeClick = useCallback(function (mode) {
        var _a, _b, _c;
        // Step 1：有树选中时，仍然把事件抛给外部（向后兼容）
        if ((_a = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.path) === null || _a === void 0 ? void 0 : _a.length) {
            var lastData = __spreadArray([], currentSelection.path, true).reverse()
                .find(function (n) { return n.type === "data"; });
            var path = (_b = currentSelection.path) !== null && _b !== void 0 ? _b : [];
            if ((lastData === null || lastData === void 0 ? void 0 : lastData.data) != null) {
                onThinkingModeClick === null || onThinkingModeClick === void 0 ? void 0 : onThinkingModeClick({
                    data: lastData.data,
                    thinkingMode: mode,
                    node: lastData,
                    path: path,
                });
                onNodeClick === null || onNodeClick === void 0 ? void 0 : onNodeClick({
                    node: lastData,
                    path: path,
                    data: lastData.data,
                    thinkingMode: mode,
                });
            }
        }
        // 优先用 ref 中的最新消息（带完整 payload），避免 state 未刷新时只传结构不传数据
        var msgToSend = (_c = lastIncomingMessageRef.current) !== null && _c !== void 0 ? _c : lastIncomingMessage;
        if (!msgToSend) {
            console.warn("⚠️ [CompsAi] 无法触发 AI 调用：缺少最近一次传入消息(lastIncomingMessage)");
            return;
        }
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var results_1, ts_1, displayContent_1, err_2, ts_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        if (loadingProp === undefined) {
                            setInnerLoading(true);
                        }
                        return [4 /*yield*/, handleIncomingMessage(msgToSend, mode.id, undefined, currentEventHashForDialog || undefined)];
                    case 1:
                        results_1 = _a.sent();
                        console.log("✅ [CompsAi] 点击思考方式，AI 返回结果:", {
                            thinkingModeId: mode.id,
                            resultKeys: Object.keys(results_1 || {}),
                            resultCount: Object.keys(results_1 || {}).length,
                        });
                        onResult === null || onResult === void 0 ? void 0 : onResult(results_1);
                        if (aiMessagesProp === undefined) {
                            ts_1 = Date.now();
                            displayContent_1 = getDisplayContentFromResults(results_1);
                            setInnerAiMessages(function (prev) { return __spreadArray(__spreadArray([], prev, true), [
                                {
                                    id: "result-".concat(msgToSend.msgId, "-").concat(mode.id, "-").concat(ts_1),
                                    content: displayContent_1 || JSON.stringify(results_1, null, 2),
                                    timestamp: ts_1,
                                    thinkingMode: {
                                        id: mode.id,
                                        label: mode.label,
                                        description: mode.description,
                                    },
                                },
                            ], false); });
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        err_2 = _a.sent();
                        // eslint-disable-next-line no-console
                        console.error("❌ [CompsAi] 点击思考方式触发 AI 调用失败:", err_2);
                        onResult === null || onResult === void 0 ? void 0 : onResult({ error: err_2.message });
                        if (aiMessagesProp === undefined) {
                            ts_2 = Date.now();
                            setInnerAiMessages(function (prev) { return __spreadArray(__spreadArray([], prev, true), [
                                {
                                    id: "error-".concat(msgToSend.msgId, "-").concat(mode.id, "-").concat(ts_2),
                                    content: "\u5904\u7406\u5931\u8D25\uFF1A".concat((err_2 === null || err_2 === void 0 ? void 0 : err_2.message) || String(err_2)),
                                    timestamp: ts_2,
                                    thinkingMode: {
                                        id: mode.id,
                                        label: mode.label,
                                        description: mode.description,
                                    },
                                },
                            ], false); });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        if (loadingProp === undefined) {
                            setInnerLoading(false);
                        }
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
    }, [
        currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.path,
        onThinkingModeClick,
        onNodeClick,
        lastIncomingMessage,
        loadingProp,
        aiMessagesProp,
        handleIncomingMessage,
        onResult,
        currentEventHashForDialog,
    ]);
    // 第二部分思考方式项点击：Shift+Ctrl(Win/Linux) 或 Shift+Command(Mac)+点击进入编辑，否则执行思考方式（调 AI）；组合键为隐藏方式，无 tip
    var handleThinkingModeItemClick = useCallback(function (mode, e) {
        if (e.shiftKey && (e.ctrlKey || e.metaKey)) {
            e.preventDefault();
            e.stopPropagation();
            if (onEditThinkingMode) {
                onEditThinkingMode(mode);
            }
            else {
                var full = currentBackendThinkingMethods.find(function (m) { return m.method_id === mode.id; });
                if (full) {
                    setEditingThinkingMethod(full);
                    setAddThinkingMethodDialogVisible(true);
                }
            }
        }
        else {
            handlePart2ThinkingModeClick(mode);
        }
    }, [
        onEditThinkingMode,
        currentBackendThinkingMethods,
        handlePart2ThinkingModeClick,
    ]);
    // 处理清理操作
    var handleClear = useCallback(function () {
        console.log("🧹 [CompsAi] 清理按钮被点击:", {
            hasOnClearAll: !!onClearAll,
            hasOnClearMessages: !!onClearMessages,
            currentSelectedKeys: selectedKeys,
            hasCurrentSelection: !!currentSelection,
        });
        // 优先使用 onClearAll（全面清理）
        if (onClearAll) {
            console.log("✅ [CompsAi] 调用 onClearAll（全面清理）");
            onClearAll();
        }
        else if (onClearMessages) {
            // 向后兼容：只清理消息
            console.log("✅ [CompsAi] 调用 onClearMessages（仅清理消息）");
            onClearMessages();
        }
        else {
            console.warn("⚠️ [CompsAi] 没有提供清理回调函数");
        }
        // 非受控模式：清理组件内部消息/加载态、组件名称
        if (aiMessagesProp === undefined) {
            setInnerAiMessages([]);
        }
        if (loadingProp === undefined) {
            setInnerLoading(false);
        }
        setEditedPayloadOverride(null);
        setDisplayComponentName("");
        displayNameComponentKeyRef.current = null;
        lastIncomingMessageRef.current = null;
        setLastIncomingMessage(null);
        setFetchedThinkingModes([]);
        setCurrentEventHashForDialog("");
        setCurrentBackendThinkingMethods([]);
        // 清理选择状态
        setSelectedKeys([]);
        setCurrentSelection(null);
        console.log("✅ [CompsAi] 已清理选择状态");
    }, [
        onClearAll,
        onClearMessages,
        selectedKeys,
        currentSelection,
        aiMessagesProp,
        loadingProp,
    ]);
    /** 仅清空「反馈结果」列表，不清空传入信息、思考方式、选择状态等 */
    var handleClearFeedbackOnly = useCallback(function () {
        if (aiMessagesProp === undefined) {
            setInnerAiMessages([]);
        }
        onClearMessages === null || onClearMessages === void 0 ? void 0 : onClearMessages();
    }, [aiMessagesProp, onClearMessages]);
    /** 刷新：先清空返回结果内容，再重新执行最近一次思考方式并从后端获取 */
    var handleRefreshFeedback = useCallback(function () {
        var _a;
        var lastMessage = aiMessages[aiMessages.length - 1];
        var lastMode = lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.thinkingMode;
        var msgToSend = (_a = lastIncomingMessageRef.current) !== null && _a !== void 0 ? _a : lastIncomingMessage;
        if (!msgToSend || !lastMode)
            return;
        // 先清空反馈结果内容
        if (aiMessagesProp === undefined) {
            setInnerAiMessages([]);
        }
        onClearMessages === null || onClearMessages === void 0 ? void 0 : onClearMessages();
        if (loadingProp === undefined)
            setInnerLoading(true);
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var results, displayContent, ts, err_3, ts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        return [4 /*yield*/, handleIncomingMessage(msgToSend, lastMode.id, true, currentEventHashForDialog || undefined)];
                    case 1:
                        results = _a.sent();
                        onResult === null || onResult === void 0 ? void 0 : onResult(results);
                        if (aiMessagesProp === undefined) {
                            displayContent = getDisplayContentFromResults(results);
                            ts = Date.now();
                            setInnerAiMessages([
                                {
                                    id: "result-".concat(msgToSend.msgId, "-").concat(lastMode.id, "-").concat(ts),
                                    content: displayContent || JSON.stringify(results, null, 2),
                                    timestamp: ts,
                                    thinkingMode: {
                                        id: lastMode.id,
                                        label: lastMode.label,
                                        description: lastMode.description,
                                    },
                                },
                            ]);
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        err_3 = _a.sent();
                        console.error("❌ [CompsAi] 刷新反馈结果失败:", err_3);
                        onResult === null || onResult === void 0 ? void 0 : onResult({ error: err_3.message });
                        if (aiMessagesProp === undefined) {
                            ts = Date.now();
                            setInnerAiMessages([
                                {
                                    id: "error-".concat(msgToSend.msgId, "-").concat(lastMode.id, "-").concat(ts),
                                    content: "\u5237\u65B0\u5931\u8D25\uFF1A".concat((err_3 === null || err_3 === void 0 ? void 0 : err_3.message) || String(err_3)),
                                    timestamp: ts,
                                    thinkingMode: {
                                        id: lastMode.id,
                                        label: lastMode.label,
                                        description: lastMode.description,
                                    },
                                },
                            ]);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        if (loadingProp === undefined)
                            setInnerLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
    }, [
        aiMessages,
        lastIncomingMessage,
        loadingProp,
        handleIncomingMessage,
        onResult,
        aiMessagesProp,
        currentEventHashForDialog,
    ]);
    // 构建按钮配置 - 使用 ContainerPanel 的内置功能
    var buttons = useMemo(function () {
        var btnConfigs = [];
        if (onSettingsClick) {
            btnConfigs.push({
                key: "settings",
                icon: _jsx(SettingOutlined, {}),
                type: "text",
                onClick: onSettingsClick,
                title: "设置",
                showTextOnHover: true, // 使用 ContainerPanel 的悬停显示文字功能
            });
        }
        // 加载旋钮已移至「反馈结果」标题行显示，此处不再添加
        // 清理按钮：优先使用 onClearAll，否则使用 onClearMessages（向后兼容）
        if (onClearAll || onClearMessages) {
            btnConfigs.push({
                key: "clear",
                icon: _jsx(ClearOutlined, {}),
                type: "text",
                onClick: handleClear,
                disabled: loading,
                title: onClearAll ? "清空所有（消息、选择、返回值、缓存）" : "清空消息",
                showTextOnHover: true, // 使用 ContainerPanel 的悬停显示文字功能
            });
        }
        return btnConfigs;
    }, [onSettingsClick, onClearAll, onClearMessages, loading, handleClear]);
    return (_jsxs("div", __assign({ style: __assign(__assign({ position: "relative" }, style), { height: height === "100%" ? "100%" : height }) }, { children: [_jsx(ContainerPanel, __assign({ title: title, height: height, buttons: buttons, contentPadding: 0, cardProps: {
                    styles: {
                        body: {
                            height: height === "100%" ? "calc(100% - 57px)" : undefined,
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                            paddingTop: "0px",
                            paddingBottom: "0px",
                            paddingLeft: "0px",
                            paddingRight: "0px",
                        },
                    },
                } }, { children: _jsxs("div", __assign({ style: {
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        gap: 0,
                        overflow: "hidden",
                    } }, { children: [_jsxs("div", __assign({ style: {
                                flex: "0 0 auto",
                                display: "flex",
                                flexDirection: "column",
                                minHeight: 0,
                            } }, { children: [_jsx("div", __assign({ style: {
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        margin: "0 0 8px",
                                    } }, { children: _jsx(Title, __assign({ level: 5, style: {
                                            margin: 0,
                                            fontSize: 12,
                                            fontWeight: 200,
                                            color: "#595959",
                                        } }, { children: _jsx("span", __assign({ onClick: function (e) {
                                                if (e.shiftKey && (e.ctrlKey || e.metaKey)) {
                                                    e.preventDefault();
                                                    if (lastIncomingMessage)
                                                        openEditPayloadModal();
                                                }
                                            } }, { children: "\u4F20\u5165\u7684\u4FE1\u606F" })) })) })), _jsx("div", __assign({ style: { padding: "0" } }, { children: antdTreeData.length > 0 ? (_jsx(Tree, { treeData: antdTreeData, showLine: false, defaultExpandAll: defaultExpandAll, selectedKeys: selectedKeys, onSelect: handleTreeSelect, blockNode: true, style: { backgroundColor: "transparent" } }, treeKey)) : lastIncomingMessage ? (_jsx("div", __assign({ style: { padding: "0 0 8px" } }, { children: _jsxs("div", __assign({ style: {
                                                padding: 12,
                                                backgroundColor: "#fafafa",
                                                borderRadius: 4,
                                                border: "1px solid #f0f0f0",
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 4,
                                            } }, { children: [_jsx(Text, __assign({ style: {
                                                        fontSize: 14,
                                                        fontWeight: 500,
                                                        color: "#262626",
                                                    } }, { children: displayComponentName ||
                                                        ((_e = effectivePayloadForDisplay === null || effectivePayloadForDisplay === void 0 ? void 0 : effectivePayloadForDisplay.metadata) === null || _e === void 0 ? void 0 : _e.label) ||
                                                        (effectivePayloadForDisplay === null || effectivePayloadForDisplay === void 0 ? void 0 : effectivePayloadForDisplay.componentType) ||
                                                        lastIncomingMessage.source.componentId })), ((_f = effectivePayloadForDisplay === null || effectivePayloadForDisplay === void 0 ? void 0 : effectivePayloadForDisplay.metadata) === null || _f === void 0 ? void 0 : _f.storeName) && (_jsx(Text, __assign({ style: {
                                                        fontSize: 12,
                                                        fontWeight: 200,
                                                        color: "#8c8c8c",
                                                    } }, { children: effectivePayloadForDisplay.metadata.storeName })))] })) }))) : null }))] })), _jsx(Divider, { style: { margin: "8px 0" } }), _jsxs("div", __assign({ style: {
                                flex: "0 0 auto",
                                display: "flex",
                                flexDirection: "column",
                                minHeight: 0,
                            } }, { children: [_jsx("div", __assign({ style: {
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        margin: "4px 0 4px",
                                    } }, { children: _jsx(Title, __assign({ level: 5, style: {
                                            margin: 0,
                                            fontSize: 12,
                                            fontWeight: 200,
                                            color: "#595959",
                                        } }, { children: _jsx("span", __assign({ onClick: function (e) {
                                                if (e.shiftKey && (e.ctrlKey || e.metaKey)) {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    if (onAddThinkingMode) {
                                                        onAddThinkingMode();
                                                    }
                                                    else {
                                                        setEditingThinkingMethod(null);
                                                        setAddThinkingMethodDialogVisible(true);
                                                    }
                                                }
                                            } }, { children: "\u601D\u8003\u65B9\u5F0F" })) })) })), currentThinkingModesForPart2.length > 0 ? (_jsx("div", __assign({ style: {
                                        padding: "0 0 8px",
                                        maxHeight: 160,
                                        overflow: "auto",
                                    } }, { children: _jsx("div", __assign({ style: {
                                            padding: 12,
                                            backgroundColor: "#fafafa",
                                            borderRadius: 4,
                                            border: "1px solid #f0f0f0",
                                            minHeight: 44,
                                        } }, { children: _jsx(List, { className: "comps-ai-thinking-modes-list", size: "small", dataSource: currentThinkingModesForPart2, style: { marginBottom: 0 }, renderItem: function (mode) {
                                                var _a;
                                                return (_jsx(List.Item, __assign({ style: { padding: "4px 0" } }, { children: _jsx(List.Item.Meta, { title: _jsx(Text, __assign({ style: { cursor: "pointer" }, onClick: function (e) {
                                                                return handleThinkingModeItemClick(mode, e);
                                                            } }, { children: mode.label })), description: _jsxs(_Fragment, { children: [mode.description ? (_jsx(Text, __assign({ type: "secondary", style: { fontSize: 12 } }, { children: mode.description }))) : null, ((_a = lastIncomingMessage === null || lastIncomingMessage === void 0 ? void 0 : lastIncomingMessage.eventData) === null || _a === void 0 ? void 0 : _a.triggerTime) && (_jsx(Text, __assign({ style: {
                                                                        display: "block",
                                                                        marginTop: 4,
                                                                        fontSize: 12,
                                                                        fontWeight: 200,
                                                                        color: "#8c8c8c",
                                                                    } }, { children: new Date(lastIncomingMessage.eventData.triggerTime).toLocaleString("zh-CN", {
                                                                        timeZone: "Asia/Shanghai",
                                                                        year: "numeric",
                                                                        month: "2-digit",
                                                                        day: "2-digit",
                                                                        hour: "2-digit",
                                                                        minute: "2-digit",
                                                                        second: "2-digit",
                                                                    }) })))] }) }) }), mode.id));
                                            } }) })) }))) : null] })), _jsx(Divider, { style: { margin: "8px 0" } }), _jsxs("div", __assign({ style: {
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                minHeight: 120,
                                overflow: "hidden",
                            } }, { children: [_jsxs("div", __assign({ style: {
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        margin: "4px 0 8px",
                                    } }, { children: [_jsx(Title, __assign({ level: 5, style: {
                                                margin: 0,
                                                fontSize: 12,
                                                fontWeight: 200,
                                                color: "#595959",
                                            } }, { children: "\u53CD\u9988\u7ED3\u679C" })), loading ? (_jsx(LoadingOutlined, { spin: true, style: { color: "#1890ff", fontSize: 14 } })) : aiMessages.length > 0 ? (_jsxs(Space, __assign({ size: 4 }, { children: [_jsx(Button, __assign({ type: "link", size: "small", icon: _jsx(ReloadOutlined, {}), onClick: handleRefreshFeedback, disabled: loading || !lastIncomingMessage || aiMessages.length === 0, style: { padding: "0 4px", fontSize: 12 } }, { children: "\u5237\u65B0" })), _jsx(Button, __assign({ type: "link", size: "small", icon: _jsx(ClearOutlined, {}), onClick: handleClearFeedbackOnly, disabled: loading, style: { padding: "0 4px", fontSize: 12 } }, { children: "\u6E05\u7406" }))] }))) : null] })), _jsx("div", __assign({ style: {
                                        flex: 1,
                                        padding: "0 0 12px",
                                        borderRadius: 4,
                                        overflow: "auto",
                                        minHeight: 100,
                                    } }, { children: aiMessages.length === 0 ? null : (_jsx("div", __assign({ style: { display: "flex", flexDirection: "column", gap: 24 } }, { children: __spreadArray([], aiMessages, true).reverse().map(function (message) {
                                            var _a, _b;
                                            return (_jsxs("div", __assign({ style: {
                                                    padding: "12px",
                                                    backgroundColor: "#fafafa",
                                                    borderRadius: 4,
                                                } }, { children: [_jsxs("div", __assign({ style: {
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: 4,
                                                            marginBottom: 8,
                                                        } }, { children: [_jsx(Text, __assign({ type: "secondary", style: { fontSize: 12 } }, { children: (_b = (_a = message.thinkingMode) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : "未知" })), _jsx(Text, __assign({ style: {
                                                                    fontSize: 12,
                                                                    fontWeight: 200,
                                                                    color: "#8c8c8c",
                                                                } }, { children: new Date(message.timestamp).toLocaleString("zh-CN", {
                                                                    timeZone: "Asia/Shanghai",
                                                                    year: "numeric",
                                                                    month: "2-digit",
                                                                    day: "2-digit",
                                                                    hour: "2-digit",
                                                                    minute: "2-digit",
                                                                    second: "2-digit",
                                                                }) }))] })), _jsx(Paragraph, __assign({ style: {
                                                            margin: 0,
                                                            whiteSpace: "pre-wrap",
                                                            wordBreak: "break-word",
                                                            fontSize: 13,
                                                        } }, { children: renderContentWithFormatting(getDisplayContent(message.content)) }))] }), message.id));
                                        }) }))) }))] }))] })) })), _jsx(AddThinkingMethodDialog, { visible: addThinkingMethodDialogVisible, onClose: function () {
                    setAddThinkingMethodDialogVisible(false);
                    setEditingThinkingMethod(null);
                }, initialMethod: editingThinkingMethod, onSaved: function () {
                    var _a;
                    if (!lastIncomingMessage)
                        return;
                    var pageIdForFetch = lastIncomingMessage.source.pageId;
                    var tokenForFetch = ((_a = lastIncomingMessage.context) === null || _a === void 0 ? void 0 : _a.token) || "";
                    var doFetch = function (eventHash) {
                        var baseUrl = apiBaseUrl !== null && apiBaseUrl !== void 0 ? apiBaseUrl : "";
                        var apiPath = baseUrl
                            ? "".concat(baseUrl, "/api/ai/get-thinking-methods")
                            : "/api/ai/get-thinking-methods";
                        var apiUrl = "".concat(apiPath, "?eventHash=").concat(encodeURIComponent(eventHash), "&pageId=").concat(encodeURIComponent(pageIdForFetch));
                        (typeof fetch !== "undefined" ? fetch : globalThis.fetch)(apiUrl, {
                            headers: { Authorization: tokenForFetch },
                        })
                            .then(function (r) { return (r.ok ? r.json() : { data: [] }); })
                            .then(function (res) {
                            var arr = Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? res.data : [];
                            setFetchedThinkingModes(arr.map(function (m) { return ({
                                id: m.method_id || m.id,
                                label: m.display_name || m.label || m.method_id || m.id,
                                description: m.brief_desc || m.description || "",
                            }); }));
                            setCurrentBackendThinkingMethods(arr);
                        })
                            .catch(function () { });
                    };
                    if (currentEventHashForDialog) {
                        doFetch(currentEventHashForDialog);
                    }
                    else {
                        var structuredPayload = getPayloadStructure(lastIncomingMessage.eventData.payload);
                        generateEventHash(JSON.stringify(structuredPayload)).then(doFetch);
                    }
                }, pageId: ((_g = lastIncomingMessage === null || lastIncomingMessage === void 0 ? void 0 : lastIncomingMessage.source) === null || _g === void 0 ? void 0 : _g.pageId) || pageId || "", eventHash: currentEventHashForDialog, token: (_h = lastIncomingMessage === null || lastIncomingMessage === void 0 ? void 0 : lastIncomingMessage.context) === null || _h === void 0 ? void 0 : _h.token, apiBaseUrl: apiBaseUrl, existingMethods: currentBackendThinkingMethods, samplePayload: effectivePayloadForDisplay || null }), _jsx(ContainerModal, __assign({ title: "\u7F16\u8F91\u4F20\u5165\u7684\u6570\u636E", visible: editPayloadModalVisible, width: 720, onCancel: function () {
                    if (editPayloadSaving)
                        return;
                    setEditPayloadModalVisible(false);
                }, footerRightButtons: [
                    {
                        key: "cancel",
                        text: "取消",
                        onClick: function () {
                            if (editPayloadSaving)
                                return;
                            setEditPayloadModalVisible(false);
                        },
                    },
                    {
                        key: "ok",
                        text: "确定",
                        type: "primary",
                        loading: editPayloadSaving,
                        onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                            var formValues, nameFromForm, descFromForm, fullPayload, nextPayload, baseUrl, apiUrl, structuredPayload, body, fetchFn, res, errorText, resJson, backendEventHash, e_1;
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                            return __generator(this, function (_l) {
                                switch (_l.label) {
                                    case 0:
                                        if (!lastIncomingMessage) {
                                            setEditPayloadModalVisible(false);
                                            return [2 /*return*/];
                                        }
                                        formValues = (_c = (_b = (_a = editPayloadFormRef.current) === null || _a === void 0 ? void 0 : _a.getFieldsValue) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : {};
                                        nameFromForm = (_d = formValues.name) !== null && _d !== void 0 ? _d : "";
                                        descFromForm = (_e = formValues.description) !== null && _e !== void 0 ? _e : "";
                                        fullPayload = (_g = effectivePayloadForDisplay !== null && effectivePayloadForDisplay !== void 0 ? effectivePayloadForDisplay : (_f = lastIncomingMessage.eventData) === null || _f === void 0 ? void 0 : _f.payload) !== null && _g !== void 0 ? _g : {};
                                        nextPayload = __assign(__assign({}, fullPayload), { metadata: __assign(__assign(__assign({}, ((fullPayload === null || fullPayload === void 0 ? void 0 : fullPayload.metadata) || {})), (nameFromForm ? { label: nameFromForm } : {})), (descFromForm ? { description: descFromForm } : {})) });
                                        setEditedPayloadOverride(nextPayload);
                                        if (nameFromForm) {
                                            setDisplayComponentName(nameFromForm);
                                        }
                                        baseUrl = apiBaseUrl !== null && apiBaseUrl !== void 0 ? apiBaseUrl : "";
                                        apiUrl = baseUrl
                                            ? "".concat(baseUrl, "/api/ai/update-component-info")
                                            : "/api/ai/update-component-info";
                                        structuredPayload = getPayloadStructure(nextPayload);
                                        body = {
                                            pageId: lastIncomingMessage.source.pageId || pageId,
                                            componentId: lastIncomingMessage.source.componentId,
                                            componentName: nameFromForm ||
                                                displayComponentName ||
                                                ((_h = nextPayload === null || nextPayload === void 0 ? void 0 : nextPayload.metadata) === null || _h === void 0 ? void 0 : _h.label) ||
                                                lastIncomingMessage.source.componentId,
                                            description: descFromForm,
                                            payload: structuredPayload,
                                        };
                                        _l.label = 1;
                                    case 1:
                                        _l.trys.push([1, 6, 7, 8]);
                                        setEditPayloadSaving(true);
                                        fetchFn = typeof fetch !== "undefined" ? fetch : globalThis.fetch;
                                        return [4 /*yield*/, fetchFn(apiUrl, {
                                                method: "POST",
                                                headers: {
                                                    "Content-Type": "application/json",
                                                    Authorization: ((_j = lastIncomingMessage.context) === null || _j === void 0 ? void 0 : _j.token) || "",
                                                },
                                                body: JSON.stringify(body),
                                            })];
                                    case 2:
                                        res = _l.sent();
                                        if (!!res.ok) return [3 /*break*/, 4];
                                        return [4 /*yield*/, res.text().catch(function () { return ""; })];
                                    case 3:
                                        errorText = _l.sent();
                                        throw new Error(errorText || res.statusText || "保存失败（服务器返回 500）");
                                    case 4: return [4 /*yield*/, res.json().catch(function () { return ({}); })];
                                    case 5:
                                        resJson = _l.sent();
                                        backendEventHash = (_k = resJson === null || resJson === void 0 ? void 0 : resJson.data) === null || _k === void 0 ? void 0 : _k.eventHash;
                                        if (backendEventHash && typeof backendEventHash === "string") {
                                            setCurrentEventHashForDialog(backendEventHash);
                                        }
                                        message.success("已保存到组件配置");
                                        // 一旦成功保存传入信息，可认为事件已在后端存在，允许添加思考方式
                                        setHasExistingEventForComponent(true);
                                        setEditPayloadModalVisible(false);
                                        return [3 /*break*/, 8];
                                    case 6:
                                        e_1 = _l.sent();
                                        // eslint-disable-next-line no-console
                                        console.error("❌ [CompsAi] 保存编辑传入的信息失败:", e_1, {
                                            apiUrl: apiUrl,
                                            body: body,
                                        });
                                        message.error("无法保存编辑传入的信息，请稍后重试或联系后台同学检查接口。");
                                        return [3 /*break*/, 8];
                                    case 7:
                                        setEditPayloadSaving(false);
                                        return [7 /*endfinally*/];
                                    case 8: return [2 /*return*/];
                                }
                            });
                        }); },
                    },
                ], contentPadding: { top: 32, bottom: 32, left: 24, right: 24 } }, { children: _jsx("div", __assign({ style: { display: "flex", flexDirection: "column", gap: 12 } }, { children: _jsx(CompsForm, { formItems: [
                            {
                                name: "name",
                                label: "名称",
                                type: "input",
                                colSpan: 24,
                                props: {
                                    placeholder: "请输入组件名称（用于展示与配置）",
                                },
                            },
                            {
                                name: "description",
                                label: "说明",
                                type: "input",
                                colSpan: 24,
                                props: {
                                    placeholder: "请输入组件说明，便于后续在配置与管理界面中识别",
                                },
                            },
                            {
                                name: "payload",
                                label: "传送信息",
                                type: "custom",
                                colSpan: 24,
                                customComponent: function () {
                                    var _a, _b;
                                    var basePayload = (_b = effectivePayloadForDisplay !== null && effectivePayloadForDisplay !== void 0 ? effectivePayloadForDisplay : (_a = lastIncomingMessage === null || lastIncomingMessage === void 0 ? void 0 : lastIncomingMessage.eventData) === null || _a === void 0 ? void 0 : _a.payload) !== null && _b !== void 0 ? _b : {};
                                    var structureJson = "";
                                    try {
                                        structureJson = JSON.stringify(getPayloadStructure(basePayload), null, 2);
                                    }
                                    catch (_c) {
                                        structureJson = "// 无法抽取结构";
                                    }
                                    return (_jsx("div", __assign({ style: {
                                            borderRadius: 6,
                                            border: "1px solid #d9d9d9",
                                            height: 260,
                                            overflowY: "auto",
                                            padding: 4,
                                        } }, { children: _jsx(Input.TextArea, { value: structureJson, readOnly: true, autoSize: false, style: {
                                                border: "none",
                                                boxShadow: "none",
                                                resize: "none",
                                                height: "100%",
                                                fontFamily: "Menlo, Monaco, Consolas, monospace",
                                                fontSize: 12,
                                            }, placeholder: "// \u4EC5\u5C55\u793A\u7ED3\u6784\uFF08\u5B57\u6BB5\u4E0E\u5C42\u7EA7\uFF09\uFF0C\u4E0D\u5305\u542B\u5177\u4F53\u6570\u636E\uFF1B\u53EF\u6839\u636E\u6B64\u7ED3\u6784\u51B3\u5B9A\u662F\u5426\u4FDD\u5B58\u4E3A\u5F85\u54CD\u5E94\u4E8B\u4EF6" }) })));
                                },
                            },
                        ], formRef: function (form) {
                            editPayloadFormRef.current = form;
                        }, initialValues: useMemo(function () {
                            var _a, _b, _c, _d;
                            var basePayload = (_b = effectivePayloadForDisplay !== null && effectivePayloadForDisplay !== void 0 ? effectivePayloadForDisplay : (_a = lastIncomingMessage === null || lastIncomingMessage === void 0 ? void 0 : lastIncomingMessage.eventData) === null || _a === void 0 ? void 0 : _a.payload) !== null && _b !== void 0 ? _b : {};
                            var rawNameFromPayload = ((_c = basePayload === null || basePayload === void 0 ? void 0 : basePayload.metadata) === null || _c === void 0 ? void 0 : _c.label) ||
                                (basePayload === null || basePayload === void 0 ? void 0 : basePayload.componentType) ||
                                (lastIncomingMessage === null || lastIncomingMessage === void 0 ? void 0 : lastIncomingMessage.source.componentId);
                            var name = displayComponentName && displayComponentName.trim().length > 0
                                ? displayComponentName
                                : rawNameFromPayload;
                            var descFromPayload = ((_d = basePayload === null || basePayload === void 0 ? void 0 : basePayload.metadata) === null || _d === void 0 ? void 0 : _d.description) || "";
                            return {
                                name: String(name || ""),
                                description: String(descFromPayload || ""),
                            };
                        }, [
                            effectivePayloadForDisplay,
                            lastIncomingMessage,
                            displayComponentName,
                        ]), onValuesChange: undefined, layout: "horizontal", labelCol: { span: 4 }, wrapperCol: { span: 20 }, contentPadding: 0 }) })) }))] })));
};
var CompsAi = forwardRef(CompsAiInner);
export default CompsAi;
export { generateMsgId, formatTriggerTime } from "./aiComponentTypes";
